import { createModule, getModuleByDomNode } from 'terrific-singleton';
import { TerrificSpec } from 'terrific-singleton/terrific-module';
import * as Cookies from 'js-cookie';
import * as Overlays from '@project/shared/utils/overlays/js/overlays';

const classes = {
	acceptButton: 'js-m-language-popup__button',
	closeButton: 'js-m-language-popup__close',
	activeClass: 'state-m-language-popup--active',
};

@createModule('LanguagePopup')
/**
 * language-popup module implementation.
 *
 */
export class LanguagePopup extends TerrificSpec {

	start(resolve: Function) {
		const $ctx = $(this._ctx);

		$(`.${classes.acceptButton}`, $ctx).on('click', this.onAcceptClick.bind(this));
		$(`.${classes.closeButton}`, $ctx).on('click', this.onCloseClick.bind(this));

		if (!this.cookieLanguagePopupRead()) {
			this.showLayer();
		}
		resolve();
	}

	/**
	 * method will accept all cookies and set language-popup to read
	 *
	 * @returns {void}
	 */
	onAcceptClick() {
		this.setLanguagePopup();
		this.hideLayer();
	}

	/**
	 * method will close language-popup in Utils
	 *
	 * @returns {void}
	 */
	onCloseClick() {
		this.setLanguagePopup();
		this.hideLayer();
	}

	/**
	 * returns if cookie notice was already read (cookielifetime 1 year // "not read" after 2 month, if not all accepted)
	 *
	 * @returns {boolean} was read
	 */
	 private cookieLanguagePopupRead(): boolean {
		const readCookie = Cookies.get('LanguagePopup');
		if (readCookie) {
			return true;
		}
		return false;
	}

	/**
	 * Saves read status of language-popup, in not already set
	 *
	 * @param {boolean} force  defines that cookie should be updated even if already set
	 * @returns {void}
	 */
	 private setLanguagePopup(): void {
		const readCookie = Cookies.get('LanguagePopup');
		if (readCookie) {
			Cookies.remove('LanguagePopup');
		}
		Cookies.set('LanguagePopup', '1', { expires: 365 });
	}

	/**
	 * method hides cookiebar
	 *
	 * @returns {void}
	 */
	hideLayer() {
		Overlays.CloseOverlay(() => $(this._ctx).removeClass(classes.activeClass));
	}

	/**
	 * method hides cookiebar
	 *
	 * @returns {void}
	 */
	showLayer() {
		Overlays.ShowOverlay(() => $(this._ctx).addClass(classes.activeClass), 250);
	}

	/**
	 * stop method, called on terrific stop
	 *
	 * @returns {void}
	 */
	stop() { }
}
